import qs from 'querystring'

import rasterizehtml from 'rasterizehtml'
import sanitizeHTML from 'sanitize-html'
import { v4 as uuidv4 } from 'uuid'

import { flow, groupBy, isEmpty, isNil } from './lodash'
import { isObjectEmpty } from './object'
import { getRoomName } from './room'

export const isDevelopment =
    process.env.NODE_ENV === 'development' ||
    process.env.REACT_APP_CUSTOM_NODE_ENV === 'DEVELOPMENT'

export const isDemo =
    process.env.REACT_APP_CUSTOM_NODE_ENV === 'DEMO' ||
    process.env.REACT_APP_CUSTOM_NODE_ENV === 'STAGING'

export const isStaging = process.env.REACT_APP_CUSTOM_NODE_ENV === 'STAGING'

export const isBeta = process.env.REACT_APP_CUSTOM_NODE_ENV === 'BETA'

export const isUIDevRoute = window.location.pathname.includes('/ui')

export const isFunction = func => typeof func === 'function'

export const isString = str => typeof str === 'string'

export const getUrlPathName = () => {
    return window.location.pathname
}

export const redirectToDashboard = queries => {
    let redirectURL = process.env.REACT_APP_DASHBOARD_URL

    if (!isObjectEmpty(queries)) {
        redirectURL += `?${qs.stringify(queries)}`
    }

    window.location = redirectURL
}

export const generateRandomId = () => {
    return Math.random()
        .toString(36)
        .substr(2, 5)
}

export const generateUUID = () => {
    return uuidv4()
}

export const extractTransformPropertyValue = (transformValue, propertyName) => {
    if (transformValue) {
        const startIndex = transformValue.indexOf(`${propertyName}(`)

        if (startIndex < 0) return -1

        const endIndex = transformValue.indexOf(')', startIndex)

        return transformValue.substring(startIndex, endIndex + 1)
    }
}

export const getScaleValue = element => {
    const transform = element.style.transform
    return extractTransformPropertyValue(transform, 'scale')
}

export const hexToRgba = (hex, a) => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    const _hex = hex.replace(shorthandRegex, (m, r, g, b) => {
        return r + r + g + g + b + b
    })

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(_hex)
    return result
        ? `rgba(${parseInt(result[1], 16)}, ${parseInt(
              result[2],
              16
          )}, ${parseInt(result[3], 16)}, ${a})`
        : null
}

export const generateDummyNotes = localUserIdentity => {
    const roomName = getRoomName()

    return [
        {
            action: 'note_save',
            note: {
                id: generateRandomId(),
                room_name: roomName,
                file:
                    'https://ohm-note-images.s3.ap-south-1.amazonaws.com/dummy/1.jpeg',
                user_id: localUserIdentity.uuid,
                created: '2021-01-18T12:28:47.910932+05:30',
                name: localUserIdentity.fullName,
            },
            timestamp: '2021-01-18 12:28:48.835289',
        },
        {
            action: 'note_save',
            note: {
                id: generateRandomId(),
                room_name: roomName,
                file:
                    'https://ohm-note-images.s3.ap-south-1.amazonaws.com/dummy/2.jpeg',
                user_id: '85aeea85-5a0c-47d8-b82e196383c8',
                created: '2021-01-18T13:28:47.910932+05:30',
                name: 'Divyanshi Jain',
            },
            timestamp: '2021-01-18 13:28:48.835289',
        },
        {
            action: 'note_save',
            note: {
                id: generateRandomId(),
                room_name: roomName,
                file:
                    'https://ohm-note-images.s3.ap-south-1.amazonaws.com/dummy/3.jpeg',
                user_id: '85aeea85-5a0c-47d8-b82e196383c7',
                created: '2021-01-18T14:28:47.910932+05:30',
                name: 'Lakshay Chawla',
            },
            timestamp: '2021-01-18 14:28:48.835289',
        },
        {
            action: 'note_save',
            note: {
                id: generateRandomId(),
                room_name: roomName,
                file:
                    'https://ohm-note-images.s3.ap-south-1.amazonaws.com/dummy/4.jpeg',
                user_id: '85aeea85-5a0c-47d8-b82e196383c6',
                created: '2021-01-18T15:28:47.910932+05:30',
                name: 'Aryan Jha',
            },
            timestamp: '2021-01-18 15:28:48.835289',
        },
        {
            action: 'note_save',
            note: {
                id: generateRandomId(),
                room_name: roomName,
                file:
                    'https://ohm-note-images.s3.ap-south-1.amazonaws.com/dummy/5.jpeg',
                user_id: '85aeea85-5a0c-47d8-b82e196383c5',
                created: '2021-01-18T16:28:47.910932+05:30',
                name: 'Akshat Verma',
            },
            timestamp: '2021-01-18 16:28:48.835289',
        },
    ]
}

export const sanitize = htmlString => {
    try {
        return sanitizeHTML(htmlString)
    } catch (error) {
        console.log('error in sanitizing html :- ', error)
    }
}

export const getGroupedResult = (input, property) => {
    const result = flow(groupBy(property))(input)

    return result
}

export const createAnswerTemplate = ({
    authorName,
    questionElement,
    answerElement,
}) => {
    return `<div style="padding: 5%; font-family: Avenir; font-size: 24px;">
            <div>
                Author: <span style="color: #009688;">${authorName}</span>
            </div>
            <div style="margin-top: 2em;">
                <div style="margin-bottom: 0.5em;">Question: </div>
                <div style="margin-left: 1em;">${questionElement}</div>
                <div style="margin-top: 2em;">
                    <div style="margin-bottom: 0.5em;">Answer: </div>
                    <div style="margin-left: 1em;">${answerElement}</div>
                </div>
            </div>
        </div>`
}

const dataURItoBlob = dataURI => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1])
    else byteString = unescape(dataURI.split(',')[1])

    // separate out the mime component
    const mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]

    // write the bytes of the string to a typed array
    let ia = new Uint8Array(byteString.length)
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
    }

    return new Blob([ia], { type: mimeString })
}

export const convertHTMLToImageFile = async element => {
    try {
        const IMAGE_WIDTH = 1000
        const IMAGE_HEIGHT = 1415

        const canvas = document.createElement('canvas')

        canvas.width = IMAGE_WIDTH
        canvas.height = IMAGE_HEIGHT

        const ctx = canvas.getContext('2d')
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)

        await rasterizehtml.drawHTML(element, canvas, {
            width: IMAGE_WIDTH,
            height: IMAGE_HEIGHT,
        })

        const imageBase64 = canvas.toDataURL('image/png')

        const responseBlob = dataURItoBlob(imageBase64)

        const file = new File([responseBlob], `${generateRandomId()}.png`, {
            type: 'image/png',
        })

        return file
    } catch (error) {
        console.log('error in converting html to image file :- ', error)
    }
}

export const detectEnvironmentFromURL = url => {
    let environment = 'DEVELOPMENT' // default value
    const modifiedURL = url.replace('https://', '').replace('http://', '')
    const regPattern = /.*(?=meets.openhouse.study\/)/gi // modifying this bcz safari doesn't support lookbehind regex

    const result = regPattern.exec(modifiedURL)

    if (!isNil(result)) {
        const extractedResult = result[0].toLowerCase()

        if (isEmpty(extractedResult)) {
            // production env
            environment = 'PRODUCTION'
        } else {
            // compare other envs
            switch (extractedResult) {
                case 'dev.':
                    environment = 'STAGING'
                    break
                case 'beta.':
                    environment = 'BETA'
                    break
                case 'demo.':
                    environment = 'DEMO'
                    break
                default:
                    break
            }
        }
    }

    return environment
}

export const isIncognito = () => {
    return new Promise((resolve, reject) => {
        const fs = window.RequestFileSystem || window.webkitRequestFileSystem

        /* check failed, assuming not in incognito */
        if (!fs) return resolve(false)

        fs(
            window.TEMPORARY,
            100,
            () => {
                // not in incognito mode
                // but dual checking with storage
                navigator.storage
                    .estimate()
                    .then(function(data) {
                        return data.quota < 120000000
                            ? resolve(true)
                            : resolve(false)
                    })
                    .catch(err => {
                        reject(err)
                    })
            },
            () => {
                resolve(true) // in incognito mode
            }
        )
    })
}

export const isStringURL = string => {
    let url
    try {
        url = new URL(string)
    } catch (err) {
        return false
    }

    return url.protocol === 'http:' || url.protocol === 'https:'
}
